export default __webpack_public_path__ + "static/media/weekly_activity_info_modal_icon.f4a03b7b.svg";